import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
/* ---------------------------------------------------------------------------------------------------- */
// PlayButton component to Show play button.
const PlayButton = ({ text, onClick }) => {
  return (
    <PlayButtonStyle>
      <div className='play-button-wrapper' onClick={() => onClick()}>
        <p>{text}</p>
      </div>
    </PlayButtonStyle>
  )
}
/* ---------------------------------------------------------------------------------------------------- */
const PlayButtonStyle = styled.div`
.play-button-wrapper{
  width: 100%;
  height: 48px;
  background-color: #FFE400;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  border-radius: 5px;

  :hover{
    background-color: #FFE450;
  }



  p{
    color: black;
    margin: auto;
    font-weight: 900;
  }

}//play-button-wrapper
`
/* ---------------------------------------------------------------------------------------------------- */
PlayButton.propTypes = {
  /** Handler function for onclick event. */
  onClick: PropTypes.func
}
/* ---------------------------------------------------------------------------------------------------- */
PlayButton.defaultProps = {
  onClick: () => { },
  text: ''
}
/* ---------------------------------------------------------------------------------------------------- */
export default PlayButton
/* ---------------------------------------------------------------------------------------------------- */
